import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconAiQuestions = React.forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...omit(props, ["className"])}
      className="yfm-icon yfm-icon-ai-questions"
    >
      <path
        d="M5 10C2.23843 10 0 7.76157 0 5C0 2.23843 2.23843 0 5 0C7.76157 0 10 2.23843 10 5C10 7.76157 7.76157 10 5 10ZM5 7.8125C5.18532 7.8125 5.33563 7.7525 5.45125 7.63281C5.56687 7.51281 5.625 7.36438 5.625 7.1875C5.625 7.01062 5.56719 6.865 5.45125 6.75094C5.33562 6.63657 5.18532 6.57406 5 6.5625C4.75687 6.57407 4.5775 6.6825 4.46188 6.8878C4.34625 7.09343 4.34625 7.29875 4.46188 7.50438C4.5775 7.70969 4.75687 7.8125 5 7.8125ZM5.47875 5.77093C5.47875 5.73501 5.46625 5.63188 5.46781 5.64657C5.455 5.51657 5.47219 5.40094 5.54344 5.28938C5.59532 5.20782 5.67563 5.13125 5.79563 5.06031C6.50125 4.64344 6.75937 4.17906 6.74468 3.69593C6.72282 2.97219 6.18969 2.26188 5.03344 2.25156C4.06686 2.2425 3.43156 2.70937 3.28125 3.58594C3.26351 3.70699 3.2938 3.83018 3.36565 3.92921C3.43751 4.02823 3.54523 4.09524 3.66581 4.11592C3.7864 4.1366 3.91029 4.10932 4.01103 4.0399C4.11178 3.97048 4.18139 3.86442 4.205 3.74437C4.27344 3.3475 4.49563 3.18407 5.02469 3.18875C5.60499 3.19407 5.79968 3.45343 5.80781 3.72375C5.80983 3.77023 5.79738 3.8162 5.77219 3.85531C5.7075 3.97156 5.56718 4.10657 5.31906 4.25313C5.07374 4.39782 4.88499 4.57782 4.7525 4.78594C4.54656 5.10938 4.50157 5.42938 4.53656 5.75468C4.54187 5.80375 4.54125 5.7975 4.54125 5.77094C4.54096 5.83269 4.55286 5.89389 4.57628 5.95102C4.59971 6.00816 4.63419 6.0601 4.67774 6.10387C4.7213 6.14764 4.77307 6.18237 4.83009 6.20607C4.88711 6.22977 4.94825 6.24197 5.01 6.24197C5.07175 6.24197 5.13289 6.22977 5.18991 6.20607C5.24693 6.18237 5.29871 6.14764 5.34226 6.10387C5.38582 6.0601 5.4203 6.00816 5.44372 5.95102C5.46715 5.89389 5.47905 5.83268 5.47875 5.77093Z"
        fill="#99A8BA"
      />
    </svg>
  )
);

IconAiQuestions.displayName = "IconAiQuestions";

export default IconAiQuestions;
